import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/vip_members',
  component: Management,
  redirect: '/vip_members/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/vip_members/List'),
      redirect: 'list/vip_members',
      meta: {
        auth: Auth.listVipMembers
      },
      children: [
        {
          path: 'list_table',
          component: () => import('@/views/vip_members/ListTable'),
          meta: {
            auth: Auth.listVipMembers,
            tabName: 'list_table'
          }
        }
      ]
    }
  ]
}
